<template>
    <div class="porduct_sign" v-loading="loading">
        <el-tabs v-model="activeName" type="card" class="demo-tabs" @tab-click="handleSign">
            <el-tab-pane v-for="item in signNum" :key="item.id" :name="item.typetitle"
                :label="item.typetitle"></el-tab-pane>
        </el-tabs>
        <div class="product_content" v-if="product.length > 0">
            <div class="image_box">
                <div class="content_left">
                    <div @click="handleProduct(product[0])" class="box_text" :title="product[0].contentTitle">
                        <img :src="product[0].contentImg[0]" :class="{ 'highlighted': highlightedIndex === 0 }"
                            class="img_style1">
                        <div class="text_style">{{ product[0].contentTitle }}</div>
                    </div>
                </div>
            </div>
            <div class="image_box1">
                <div class="content_right" v-for="(pro, idx) in product.slice(1, 5)" :key="pro.id">
                    <div class="right_text">
                        <div @click="handleProduct(pro)" class="box_text" :title="pro.contentTitle">
                            <img :src="pro.contentImg[0]" class="img_style" />
                            <div class="text_style">{{ pro.contentTitle }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else style="display: flex;justify-content: center;">
            <el-empty :image-size="100" description="暂无内容..." />
        </div>
        <div v-if="product.length >= 6">
            <el-button
                style="width: calc(490 * var(--groot-ui-rpx)); height: calc(60 * var(--groot-ui-rpx));margin: 20px 0 0 0;"
                @click="moerProduct">
                <span style="font-size: calc(20 * var(--groot-ui-rpx));">查看更多产品</span>
            </el-button>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getContentList, getCategoryList } from '@/utils/api';
const router = useRouter();
import { useStore } from '@/store/index';
const store = useStore();

const highlightedIndex = ref(null);
const activeName = ref('全部');
const signNum = ref([]);
const product = ref([]);
const loading = ref(false);

const handleSign = async () => {
    await _contentGet();
};

const handleProduct = (productItem) => {
    router.push({
        path: '/productDetail',
        query: { currentId: productItem.id, categoryId: productItem.categoryId, isHome: true }
    });
    window.scrollTo(0, 0);
};

const moerProduct = () => {
    router.push({
        path: '/pageDetail',
        query: { title: activeName.value }
    });
};

const _categoryGet = async (id) => {
    product.value = [];
    loading.value = true;
    const response = await getContentList({ categoryId: id });
    if (response.rows?.length) {
        const infos = response.rows.filter(v => v.contentType !== 'banner');
        product.value = infos.map(v => ({
            contentImg: v.contentImg ? JSON.parse(v.contentImg).map(img => process.env.VUE_APP_FILE_URL + img.url) : '',
            contentTitle: v.contentTitle,
            id: v.id,
            contentDetails: v.contentDetails,
            contentDatetime: v.contentDatetime,
            categoryId: v.categoryId
        }));
    }
    loading.value = false;
};

const _contentGet = async () => {
    const response = await getCategoryList();
    response.rows.forEach((item) => {
        if (item.categoryTitle === '产品中心') {
            const filteredChildren = item.childrenList.filter(item => item.typekeyword === 'tag');
            signNum.value = [...filteredChildren];
            filteredChildren.forEach((items) => {
                items.childrenList.forEach((lastItem) => {
                    signNum.value.push(lastItem);
                });
            });
            filteredChildren.forEach((secondItem) => {
                if (secondItem.categoryTitle === '全部') {
                    if (activeName.value === '全部') {
                        _categoryGet(secondItem.id);
                    } else {
                        secondItem.childrenList.forEach((lastItem) => {
                            if (lastItem.categoryTitle === activeName.value) {
                                _categoryGet(lastItem.id);
                            }
                        });
                    }
                }
            });
        }
    });
};

onMounted(async () => {
    loading.value = true;
    product.value = store.allData['/productCenter'];
    loading.value = false;
    await _contentGet();
});
</script>

<style scoped lang="less">
// 样式部分保持不变
.porduct_sign {
    color: #666666 !important;

    .demo-tabs {
        color: #666666;
    }
}

.product_content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex: 1;

    .image_box {
        width: 49%;
    }

    .image_box1 {
        width: 49%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: space-between;
    }

    .img_style,
    .img_style1 {
        transition: transform 0.5s;
        height: calc(190 * var(--groot-ui-rpx)) !important;
        display: block;
        width: 100%;
        object-fit: cover;
    }

    .img_style1 {
        height: calc(402 * var(--groot-ui-rpx)) !important;
        object-fit: cover;
    }


    .content_left {
        width: 100%;
        overflow: hidden;
        // border-radius: 5px;
        height: 100%;
        position: relative;

        .text_style {
            position: absolute;
            top: 93%;
            left: 50%;
            height: 3.75em;
            color: white;
            text-align: left;
            box-shadow: inset 0 -53px 14px -6px rgba(0, 0, 0, 0.4);
            transform: translate(-50%, -50%);
            width: 100%;
            padding: 10px;
            font-size: calc(16 * var(--groot-ui-rpx));
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

    }

    .content_right {
        width: 49%;
        height: 49%;

        .text_style {
            position: absolute;
            top: 88%;
            left: 50%;
            color: white;
            text-align: left;
            box-shadow: inset 0 -41px 14px -6px rgba(0, 0, 0, 0.4);
            transform: translate(-50%, -50%);
            width: 100%;
            padding: 10px;
            height: 2.75em;
            font-size: calc(16 * var(--groot-ui-rpx));
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .img_box {
            width: 50%;
            height: 200px;
        }

        .box_text {
            position: relative;
            overflow: hidden;
            height: 100%;
            // border-radius: 5px;
        }

        .right_text {
            width: 99%;
            height: 100%;
        }
    }

    .highlighted {
        // height: 50px;
        background-color: #025a2c !important;
        color: #fff;
    }
}


button:hover {
    background-color: #025a2c;
    color: white;
}

.box_text:hover .img_style {
    transform: scale(1.1);
}

.box_text:hover .img_style1 {
    transform: scale(1.1);
}

.product_pag {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 0 0 30px 0;
}

::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
    border: none !important;
}

::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item {
    border: none !important;
}

::v-deep .el-tabs__item:hover {
    color: #025a2c !important;
}

::v-deep .el-tabs__item.is-active {
    color: #025a2c !important;
    // background-color: #9BA39D;
    background-color: #eef5f0;
    border: none;
    border-radius: 10px;
}

::v-deep .el-pager li.active span {
    background-color: #025a2c !important;
    color: #ffffff !important;
}

::v-deep .el-pagination .btn-next,
.el-pagination .btn-prev {
    color: #000;
    background-color: #EEEEEE;
}

// ::v-deep .el-pagination button:hover {
//     color: #025a2c !important;
// }

::v-deep .el-pagination.is-background .el-pager li.is-active {
    background-color: #025a2c;
}

::v-deep .el-pager li:hover {
    color: #025a2c !important;
}

::v-deep .el-pager li.is-active:hover {
    color: #fff !important;
}

::v-deep .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item {
    color: #666666;
    font-size: calc(20 * var(--groot-ui-rpx));
    height: 2em;
    margin: 0 25px 0 0;
}

::v-deep .el-tabs--card>.el-tabs__header {
    border: none;
}

::v-deep .el-empty {
    width: calc(300 * var(--groot-ui-rpx));
    height: calc(300 * var(--groot-ui-rpx));
    font-size: calc(14 * var(--groot-ui-rpx)) !important;
}

::v-deep .el-empty__description {
    font-size: calc(14 * var(--groot-ui-rpx)) !important;
}

::v-deep .empty {
    display: flex;
    justify-content: center;
}

@media(max-width :900px) {
    ::v-deep .el-empty__description p {
        font-size: 8px !important;
    }
}

@media(max-width :500px) {
    ::v-deep .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item {
        margin: 0 0px 0 0;
    }
}

::v-deep .el-tabs__header {
    overflow: hidden;
}

::v-deep .el-tabs__nav-scroll {
    overflow: visible;
}

::v-deep .el-tabs__nav-prev,
.el-tabs__nav-next {
    display: none;
}

@media(max-width :500px) {
    ::v-deep .el-empty__image svg {
        color: var(--el-svg-monochrome-grey);
        height: 100%;
        vertical-align: top;
        width: 53% !important;
    }
}

@media(max-width :789px) {
    ::v-deep .el-tabs__nav-wrap.is-scrollable {
        padding: 0 !important;
    }
}
</style>